import { OverlayRef } from '@angular/cdk/overlay';
import { Subject } from 'rxjs';
import { TemplateRef, Type } from '@angular/core';

export type PopoverCloseEvent = {
  type: 'backdropClick' | 'close';
  data: any;
};

export type PopoverContent = TemplateRef<any> | Type<any> | string;

export class PopoverRef {
  private afterClosed = new Subject<PopoverCloseEvent>();
  // afterClosed$ = this.afterClosed.asObservable();

  constructor(
    public overlay: OverlayRef,
    public content: PopoverContent,
    public data: any,
    public classStr: string
  ) {
    overlay.backdropClick().subscribe(() => {
      this._close('backdropClick', null);
    });
    overlay.keydownEvents().subscribe(() => {
      this._close('backdropClick', null);
    });
  }

  close(data?: any) {
    this._close('close', data);
  }

  private _close(type: PopoverCloseEvent['type'], data?: any) {
    this.overlay.dispose();
    this.afterClosed.next({
      type,
      data
    });
    this.afterClosed.complete();
  }
}
